import React from "react";

const Footer = () => {
  return (
    <footer
      style={{
        padding: "20px",
        backgroundColor: "#ff7e00",
        color: "white",
        textAlign: "center",
      }}
    >
      <p>© {new Date().getFullYear()} Westfield Transport Ltd. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
